/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Recipe_Notes_LabelInputs */

const en_recipe_notes_label = /** @type {(inputs: Recipe_Notes_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notes`)
};

const de_recipe_notes_label = /** @type {(inputs: Recipe_Notes_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notizen`)
};

/**
* | output |
* | --- |
* | "Notes" |
*
* @param {Recipe_Notes_LabelInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const recipe_notes_label = /** @type {((inputs?: Recipe_Notes_LabelInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Recipe_Notes_LabelInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_recipe_notes_label(inputs)
	return en_recipe_notes_label(inputs)
});